module.exports = __webpack_public_path__ + "static/assets/7cff5478255bc83c6cab108d98d20faf.svg";